export default "__VITE_ASSET__K3crSZCb__"